import { createContext } from "react";

import { LoginControllerApi } from "@dopingtech/teacher_plus_bff_api_ts";

import { ApiContextProps } from "./Api.model";

const apiContextInitialValues: ApiContextProps = {
  LoginControllerApi: new LoginControllerApi(),
};

export const ApiContext = createContext<ApiContextProps>(
  apiContextInitialValues,
);
